import headOfficeInfo from '@/constants/hubAdjustment/headOfficeInfo';
// @ts-ignore
const state = {
    filterOption: {
        selectedMonth: '',
    },
    hubMainReport: null,
    selectedHubInfo: null,
    headOfficeInfo,
};
export default state;
